import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { configBonusList, configLevelList, configGradeList } from '@/api/apis';
import bonus0 from '@/views/pages/sysconfig/bonusConfig/bonus0.vue';
import bonus1 from '@/views/pages/sysconfig/bonusConfig/bonus1.vue';
import bonus2 from '@/views/pages/sysconfig/bonusConfig/bonus2.vue';
import bonus10 from '@/views/pages/sysconfig/bonusConfig/bonus10.vue';
import bonus11 from '@/views/pages/sysconfig/bonusConfig/bonus11.vue';
import grade from '@/views/pages/sysconfig/bonusConfig/grade.vue';
export default {
  name: 'index',
  components: {
    bonus0: bonus0,
    bonus1: bonus1,
    bonus2: bonus2,
    bonus10: bonus10,
    bonus11: bonus11,
    grade: grade
  },
  data: function data() {
    return {
      activeName: '1',
      bonusList: [],
      gradeList: [],
      levelList: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    configGradeList().then(function _callee2(res) {
      return regeneratorRuntime.async(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.gradeList = res.rows;
              configBonusList().then(function _callee(res) {
                var data;
                return regeneratorRuntime.async(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        data = res.rows;
                        console.log("configBonusList", data);
                        _this.bonusList = data;

                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }
                });
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      });
    });
    configLevelList().then(function _callee3(res) {
      return regeneratorRuntime.async(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this.levelList = res.rows;

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      });
    });
  },
  methods: {}
};